import React from 'react';
import PropTypes from 'prop-types';
import BookingFilter from 'components/form/filters/BookingFilter';
import CancelledFilter from 'components/form/filters/CancelledFilter';
import CancelledAtFilter from 'components/form/filters/CancelledAtFilter';
import CreatedAtFilter from 'components/form/filters/CreatedAtFilter';
import DestinationArrivalDateFilter from 'components/form/filters/DestinationArrivalDateFilter';
import DestinationDepartureDateFilter from 'components/form/filters/DestinationDepartureDateFilter';
import ProductIdFilter from 'components/form/filters/ProductIdFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SubscriptionFilter from 'components/form/filters/SubscriptionFilter';
import TextFilter from 'components/list/Filters/types/TextFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import authHelper from 'helpers/auth';
import ProductCategoryIdFilter from 'components/form/filters/ProductCategoryIdFilter';
import SubCategoryIdFilter from 'components/form/filters/SubCategoryIdFilter';

const LicensePlateComponent = <TextFilter
    label='resources.reservations.fields.license_plate'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='license_plate'
/>;

const LastNameComponent = <TextFilter
    label='resources.reservations.fields.last_name'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
    source='last_name'
/>;

const InternalOrderIdComponent = <TextFilter
    label='filters.components.orderId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='internal_order_id'
/>;

const RemoteReferenceComponent = <TextFilter
    label='resources.reservations.fields.remote_reference'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='remote_reference'
/>;

const ReservationsListFilters = (props) => {
    const filters = {
        basic: {
            license_plate: {
                component: LicensePlateComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            last_name: {
                component: LastNameComponent,
                matchTypes: {
                    default: filterMatchTypes.startsWith,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            internal_order_id: {
                component: InternalOrderIdComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
        advanced: {
            created_at: {
                component: CreatedAtFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            cancelled: {
                component: CancelledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            cancelled_at: {
                component: CancelledAtFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            destination_arrival_date: {
                component: DestinationArrivalDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            destination_departure_date: {
                component: DestinationDepartureDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            product_id: {
                component: ProductIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            product_category_id: {
                component: ProductCategoryIdFilter,
                matchTypes: {
                    default: filterMatchTypes.matchOneOf,
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            subcategory_id: {
                component: SubCategoryIdFilter,
                matchTypes: {
                    default: filterMatchTypes.matchOneOf,
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
    };

    if (authHelper.isAdmin()) {
        filters.advanced = Object.assign({}, filters.advanced, {
            is_subscription: {
                component: SubscriptionFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            is_booking: {
                component: BookingFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            remote_reference: {
                component: RemoteReferenceComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.contains,
                    ],
                },
            },
            subscription_id: {
                component: <TextFilter
                    label='resources.reservations.fields.subscription_id'
                    options={ {
                        fullWidth: true,
                        floatingLabelFixed: true,
                    } }
                    source='subscription_id'
                />,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        });
    }

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

ReservationsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default ReservationsListFilters;



// WEBPACK FOOTER //
// ./src/pages/reservations/list/ReservationsListFilters.js